<template>
    <div id="company_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    Company Info
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content company-info">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="companyInfoForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name"># Account:</label>
                                        <input type="text" class="form-control" v-model="account_number" id="account_number" placeholder="Enter Account Number" name="account_number">
                                        <div class="field-error">{{account_number_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Billing Address:</label>
                                        <input type="text" class="form-control" v-model="billing_address" id="billing_address" placeholder="Enter Billing Address" name="billing_address">
                                        <div class="field-error">{{billing_address_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Office Address:</label>
                                        <input type="text" class="form-control" v-model="office_address" id="office_address" placeholder="Enter Office Address" name="office_address">
                                        <div class="field-error">{{office_address_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="state">State:</label>
                                        <v-select v-model="state" name="state"
                                                label="text" :filterable="false" :options="stateArr"
                                                @search="onSearchState"
                                                placeholder="Select State" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search State...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ state_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="city_id">City:</label>
                                        <a href="javascript:void(0)" v-on:click="addNewCity()" class="pull-right color-blue link-text"> <i class="fp-add font-weight-bold" style="font-size:10px;"></i> Add City</a>
                                        <v-select v-model="city_id" name="city_id"
                                                label="text" :filterable="false" :options="cityArr"
                                                @search="onSearchCity"
                                                placeholder="Select City" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search City...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{city_error_mssg}}</div>
                                        <div class="field-error">{{ city_error_msg }}</div>
                                        <template v-if = "canAddCity">
                                          <div class="citycreate wo-vendorinv-form" >
                                              <city-add-form :id="'addCity'" v-on:populateCityId="popCityName($event)" class="citycreate wo-vendorinv-panel"></city-add-form>
                                          </div>
                                    </template>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Zip Code:</label>
                                        <input type="text" class="form-control" v-model="zip_code" id="zip_code" placeholder="Enter Zip Code" name="zip_code" @keypress="isIntegerCheck($event)">
                                        <div class="field-error">{{zip_code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Tin No.:</label>
                                        <input type="text" class="form-control" v-model="tin_no" id="tin_no" placeholder="Enter Tin No." name="tin_no">
                                        <div class="field-error">{{tin_no_error_msg}}</div>
                                    </div>
                                    <div class="col form-group" id="phone-hide">
                                        <label class="control-label require" for="phone">Phone No:</label>
                                        <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="phone" id="phone" placeholder="999-999-9999" name="phone">
                                        <!-- <input-mask id="phone" :alwaysShowMask="true" name="phone" v-model="phone" mask="999-999-9999" class="form-control" type="tel"></input-mask> -->
                                        <div class="field-error">{{phone_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Email:</label>
                                        <input type="text" class="form-control" v-model="email" id="email" placeholder="Enter Email" name="email">
                                        <div class="field-error">{{email_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-group" >
                                    <div class="alert alert-success hide" id="alertSuccess">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong>Company Info Saved Successfully.</strong>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateCompanyInfoBtn" class="btn btn-primary" v-on:click.prevent="CreateCompanyInfo" >
                                        <i class="fp-save"> </i>  Save
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

import CityCreate from '@/components/CityCreate.vue';
Vue.component("city-add-form", CityCreate);


export default {
    name: "CompanyInfo",

    mixins:[commonMixins,contractMixins],
    data: () => ({
        canAddCity:false,
        city_error_mssg:"",
        permissions: [],
        cantAccessPage: "",
        loading:false,
        name:"",
        billing_address:"",
        office_address:"",
        zip_code:"",
        tin_no:"",
        phone:"",
        email:"",
        state:"",
        city_id:"",
        name_error_msg:"",
        billing_address_error_msg:"",
        office_address_error_msg:"",
        zip_code_error_msg:"",
        tin_no_error_msg:"",
        phone_error_msg:"",
        email_error_msg:"",
        state_error_msg:"",
        city_error_msg:"",
        stateArr:[],
        cityArr:[],
        flag:"create",
        id:0,
        account_number_error_msg:'',
        account_number:'',
    }),
    watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_company_info') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },

        //if state value update after then change the city value also update that in thie module.
        state: function(state) {

            var self = this;

            if(self.state == null || self.state == ""){
                self.city_id = null;
                self.cityArr = [];
            }
        }
   },
   created: function() {

   },
   mounted: function() {
        var self = this;
        this.getPermissions();
        setTimeout(function(){
            self.loadCompanyInfo();
        },100);
   },
   methods: {
      popCityName(cid){
         console.log("check"+cid);
        // this.city_id =cid;
         this.city_id = {value: cid.id, text: cid.name};
       },
       addNewCity:function(){
          var self = this;
          var error = false;
          self.city_error_mssg = "";
          var path = window.location.pathname;
          var segments = path.split("/");
          console.log(segments[3]);


            if (self.state != null && self.state != 0 && self.state == "") {
              self.canAddCity = true;

            }else{
              self.city_error_mssg = "Please select the state first!!";
                error = true;

            }
      },
      onSearchState(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'state', '');
        }
      },

      onSearchCity(search, loading) {

        var self = this;
        if (search.length > 2) {

            if ( self.state == null || self.state.value == "" ) {
                alert("please select state first");
                return;
            }

            loading(true);
            self.searchField(loading, search, 'city', '');
        }
      },

      CreateCompanyInfo() {
            var self = this;
            var error = false;

            self.name_error_msg = "";
            self.billing_address_error_msg = "";
            self.office_address_error_msg = "";
            self.state_error_msg = "";
            self.city_error_msg = "";
            self.zip_code_error_msg = "";
            self.tin_no_error_msg = "";
            self.phone_error_msg = "";
            self.email_error_msg = "";
            self.account_number_error_msg ='';

            if (!self.name || self.name == null || self.name == "") {
                self.name_error_msg = "Name Required.";
                error = true;
            }

            if (!self.account_number || self.account_number == null || self.account_number == "") {
                self.account_number_error_msg = "Account Number Required.";
                error = true;
            }

            if (!self.billing_address || self.billing_address == null || self.billing_address == "") {
                self.billing_address_error_msg = "Billing Address Required.";
                error = true;
            }

            if (!self.office_address || self.office_address == null || self.office_address == "") {
                self.office_address_error_msg = "Office Address Required.";
                error = true;
            }

            if (!self.state || self.state == null || self.state == "") {
                self.state_error_msg = "State Required.";
                error = true;
            }

            if (!self.city_id || self.city_id == null || self.city_id == "") {
                self.city_error_msg = "City Required.";
                error = true;
            }

            if (!self.zip_code || self.zip_code == null || self.zip_code == "") {
                self.zip_code_error_msg = "Zip Code Required.";
                error = true;
            }
             if(self.zip_code && (self.zip_code.length > 5 || self.zip_code.length < 5) ){
                  self.zip_code_error_msg = "Zip Must Consist of 5 Digits";
                  error = true;
                }

            if (!self.tin_no || self.tin_no == null || self.tin_no == "") {
                self.tin_no_error_msg = "Tin No. Required.";
                error = true;
            }

            if (!self.phone || self.phone == null || self.phone == "") {
                self.phone_error_msg = "Phone No Required.";
                error = true;
            }

            var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

            if(self.phone && !self.phone.match(phoneRE)){
                self.phone_error_msg = "Phone No is not in proper format please update";
                error = true;
            }

            if (!self.email || self.email == null || self.email == "") {
                self.email_error_msg = "Email Required.";
                error = true;
            }

            if (self.email && !self.validEmail(self.email)) {
                self.email_error_msg = "Email Must Be In Proper Email Format.";
                error = true;
            }

            if (!error) {
                self.loading = true;
                var fields = $("#companyInfoForm").serializeArray();
                fields.push({ name: "state_id", value: self.state.value });
                fields.push({ name: "city_id", value: self.city_id.value });
                fields.push({ name: "flag", value: self.flag });
                if (self.flag == "update") {
                    fields.push({ name: "id", value: self.id });
                }
                $("#CreateCompanyInfoBtn").text('Saving ...');
                $("#CreateCompanyInfoBtn").prop('disabled',true);

                $.ajax({
                    url: process.env.ROOT_API + "/company-info/create",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        $("#CreateCompanyInfoBtn").text('Save');
                        $("#CreateCompanyInfoBtn").prop('disabled',false);
                        if (data.status == "success") {
                            self.flag = "update";
                            self.loadCompanyInfo();
                            setTimeout(function() {
                                $(".alert-success").toggleClass("show");
                                setTimeout(function() {
                                    $(".alert-success").removeClass("show");
                                    $(".alert-success").addClass("hide");
                                }, 10000);
                            },100);

                        } else {
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                    self.common_error_msg += data.content[i] + "\n";
                                }
                                $("#errorMsg").html(err);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $("#CreateCompanyInfoBtn").text('Save');
                        $("#CreateCompanyInfoBtn").prop('disabled',false);
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            $("#errorMsg").html(jqXHR.responseJSON.message);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                });
            }else{
                self.errorValidationFocus();
            }
      },
      loadCompanyInfo() {
          var self = this;
          self.loading = true;
          $.ajax({
            url: process.env.ROOT_API + "/company-info",
            type: "POST",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    if (data.content.flag == "update") {
                        self.flag = data.content.flag;
                        self.id = data.content.id;
                        self.name = data.content.name;
                        self.billing_address = data.content.billing_address;
                        self.office_address = data.content.office_address;
                        self.state = {
                            text:data.content.state,
                            value:data.content.state_id
                        };
                        self.city_id = {
                            text:data.content.city,
                            value:data.content.city_id
                        };
                        self.zip_code = data.content.zip_code;
                        self.tin_no = data.content.tin_no;
                        self.phone = data.content.phone;
                        self.email = data.content.email;
                        self.account_number = data.content.account_number;

                    }else{
                        self.flag = data.content.flag;
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;

                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        //EventBus.$emit("logged-in", true, "", "");
                        self.$router.push("/");
                    }
                    $("#errorMsg").html(jqXHR.responseJSON.message);
                    $(".alert-warning").toggleClass("show");
                    setTimeout(function () {
                        $(".alert-warning").removeClass("show");
                        $(".alert-warning").addClass("hide");
                    }, 10000);
                }
            }
        });

      },
      validEmail: function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CompanyInfo.vue